import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", {
  key: "familyMemberCountLabel",
  class: "input__label",
  textContent: 'Hvor mange børn der skal forsikres?'
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "pt-5",
  key: "spacer"
}, null, -1)
const _hoisted_3 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_FamilyMemberComponent = _resolveComponent("FamilyMemberComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_SelectModalComponent, {
      key: "familyMemberCount",
      id: "familyMemberCount",
      name: "familyMemberCount",
      preSelect: _ctx.model.familyInfo.personCount,
      autocomplete: "off",
      placeholder: "Vælg børn der skal forsikres",
      innerData: _ctx.cms.personCountList,
      selected: _ctx.model.familyInfo.personCount !== undefined,
      readonlyValue: undefined,
      visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
      errorMsgOverride: "Vælg hvor mange børn der skal forsikres",
      "onSelectModalComponent:selected": _ctx.familyMemberCountSelected
    }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"]),
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.familyInfo.personCountId + 1, (inx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'ch' + inx
      }, [
        (_openBlock(), _createBlock(_component_FamilyMemberComponent, {
          key: 'cc' + (inx - 1),
          personNo: inx - 1,
          placeholderName: "F.eks. Lisa Sofie Jensen",
          labelName: "Dit barns fulde navn",
          placeholderAge: "",
          labelAge: "Dit barns alder",
          placeholderWork: "Indtast f.eks Maskintekniker...",
          labelWork: "Hvad arbejder dit barn med?",
          labelQuestionWork: _ctx.cms.workForMinorsLabel,
          card: _ctx.card
        }, null, 8, ["personNo", "labelQuestionWork", "card"]))
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ButtonTapComponent, {
        class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
        textContent: _toDisplayString(_ctx.card.linkText),
        "data-gtm": _ctx.cms.dataGtm,
        "data-gtm-click-text": _ctx.card.routePath
      }, null, 8, ["class", "textContent", "data-gtm", "data-gtm-click-text"])
    ])
  ]))
}